<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
    <circle cx="35" cy="35" r="33" stroke="#AFAFBE" stroke-width="4" />
    <circle cx="23.0588" cy="27.1764" r="3.29412" fill="#AFAFBE" />
    <circle cx="46.9412" cy="27.1764" r="3.29412" fill="#AFAFBE" />
    <path
      d="M49.4117 39.5293C49.4117 41.3678 49.0496 43.1883 48.3461 44.8869C47.6425 46.5854 46.6113 48.1288 45.3112 49.4288C44.0112 50.7288 42.4679 51.76 40.7693 52.4636C39.0708 53.1672 37.2502 53.5293 35.4117 53.5293C33.5732 53.5293 31.7527 53.1672 30.0542 52.4636C28.3556 51.76 26.8123 50.7288 25.5122 49.4288C24.2122 48.1288 23.181 46.5854 22.4774 44.8869C21.7739 43.1883 21.4117 41.3678 21.4117 39.5293"
      stroke="#AFAFBE"
      stroke-width="4"
      stroke-linecap="round"
      class="smile"
    />
  </svg>
</template>
